var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgNoise = function SvgNoise(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 36,
    height: 38,
    viewBox: "0 0 2.01 2.15",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fil0{fill:#000}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1962335552224"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M1.05.05h.15V.2h-.15zM.65.33h.17V.5H.65zM1.08.46h.2v.2h-.2zM.27.7h.2v.2h-.2zM1.32.88h.2v.2h-.2zM.89.9h.2v.2h-.2zM1.52.47h.2v.2h-.2zM.38 0h.2v.2h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M1.52.47h.2v.2h-.2zM1.15 1.33h.2v.2h-.2zM.77 1.47h.12v.12H.77zM.37 1.3h.2v.2h-.2zM0 1.65h.2v.2H0zM.47 1.94h.2v.2h-.2zM1.72.94h.2v.2h-.2zM1.61 1.49h.14v.14h-.14zM1.32 1.78h.2v.2h-.2zM.6.95h.17v.17H.6zM1.86.22h.15v.15h-.15zM.09.33h.12v.12H.09z"
  })))));
};

export default SvgNoise;